import type { TOC } from '@ember/component/template-only';
import { PrismCheckbox } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

import type { RateGroupRow } from '../rate-groups-accordion';

interface TdAutomationCheckboxSignature {
  Args: {
    row: RateGroupRow;
  };
}

/* Read-only in this ticket: toggling automation per rate group comes with the
   editable rate group rows. */
const TdAutomationCheckbox = <template>
  <PrismCheckbox
    @checked={{@row.automationOn}}
    @disabled={{true}}
    aria-label={{t "pricing_manager.automation_on"}}
    data-test-id="rate-group-automation-checkbox"
  />
</template> satisfies TOC<TdAutomationCheckboxSignature>;

export default TdAutomationCheckbox;
